<template>
  <div>
    <v-card class="mb-3 sticky-element" :class="stickyClass">
      <v-layout row wrap justify-space-between align-center>
        <v-flex xs12 sm6 class="pa-2">
          <v-layout row wrap>
            <v-flex shrink class="text-xs-center mr-3">
              <v-avatar size=48 >
                <v-icon color="primary" large>wallet</v-icon>
              </v-avatar>
            </v-flex>
            <v-flex shrink class="grey--text" >
              <h1 class="grey--text text--darken-2">
                Subscription
              </h1>
              <h3>{{ seatsAvailable }} {{ seatsAvailable > 1 ? 'seats' : 'seat'}} remaining, {{ seatsUsed }} active {{ seatsAvailable > 1 ? 'users' : 'user'}}</h3>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex class="text-xs-right mr-3">
          <v-btn flat small color="primary" to="/jargon/policy">
            Policies
          </v-btn>|
          <v-btn flat small color="primary" to="/jargon/pricing">
            Pricing
          </v-btn>|
          <v-btn flat small color="primary" to="/jargon/contact">
            Contact us
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>

    <v-tooltip v-if="project && permit.canCreatePurchase(project)"
      bottom
      fixed
      color="#fff"
      >
      <v-btn fab
        color="#0155a8"
        right
        bottom
        fixed
        medium
        slot="activator"
        class="mb-4"
        @click="newPurchase = !newPurchase"
        >
        <v-icon medium color="white">person_add</v-icon>
      </v-btn>
      <span class="black--text">Add seats</span>
    </v-tooltip>

    <v-layout row wrap mb-4>
      <v-flex>
        <v-expansion-panel v-model="panel">
          <v-expansion-panel-content class="v-expansion-panel-purchases">

            <template v-slot:header>
              <v-layout row class="subheading" >
                <v-flex class="white--text">
                  <v-icon color="white" class="pr-3">list</v-icon>
                  All Purchases
                </v-flex>
              </v-layout>
            </template>

            <v-card>
              <v-data-table
                :headers="headers"
                :items="purchases"
                :total-items="totalPurchases"
                :loading="loading"
                :pagination.sync="pagination"
                :must-sort="true"
                no-data-text="No purchases yet"
                >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left link">
                    {{props.item.attributes.created_at |formatDateTime}}
                    <br>
                    {{props.item.attributes.created_at |formatDateAgo}}
                  </td>
                  <td class="text-xs-left link">
                    {{props.item.attributes.seats}}
                  </td>
                  <td class="text-xs-left link">
                    <div class="ml-2" v-if="props.item.attributes.processed_at">
                      {{props.item.attributes.processed_at |formatDateTime}}
                      <br>
                      <span class="grey--text">{{props.item.attributes.processed_at |formatDateAgo}}</span>
                    </div>
                    <div v-else>
                      <v-btn small color="primary" @click="checkPurchase(props.item)" :disabled="checking">
                        <v-icon class="mr-2" small>check</v-icon>Check progress
                      </v-btn>
                    </div>
                  </td>
                </template>
              </v-data-table>
              <div class="pb-4">
                <!-- Last line to provide padding for the favbuttons -->
              </div>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </v-layout>

    <v-dialog
      :fullscreen="$vuetify.breakpoint.xsOnly"
      v-model="newPurchase"
      max-width="65%"
      persistent
      lazy
      >
      <purchaseNew :project="project" ></purchaseNew>
    </v-dialog>

  </div>
</template>

<script>
  import { EventBus } from '@/utilities/event-bus'

  import authentication from '@/utilities/authentication'
  import permissions from '@/utilities/permissions'

  import projectService from '@/services/project'
  import purchaseService from '@/services/purchase'

  import purchaseNew from '@/components/purchase/_new'

  export default {
    name: 'purchase-index',

    props: ['projectId'],

    data () {
      return {
        auth: authentication,
        permit: permissions,
        project: null,
        purchases: [],
        totalPurchases: 0,
        newPurchase: false,
        loading: false,
        checking: false,
        panel: null,
        headers: [
          { text: 'Date', value: 'created_at', align: 'left' },
          { text: 'Seats', value: 'seats', align: 'left', sortable: false },
          { text: 'Processed', value: 'processed_at', align: 'left', sortable: false }
        ],
        pagination: {
          rowsPerPage: parseInt(authentication.preferences().page_size) || 5,
          sortBy: ('created_at'),
          descending: false
        }
      }
    },

    components: {
      purchaseNew
    },

    watch: {
      pagination: {
        handler (val) {
          if (!this.loading) {
            this.loadPurchases()
          }
        },
        deep: true
      }
    },

    mounted () {
      this.loadProject()
      this.loadPurchases()

      EventBus.$on('project-purchase', (payload) => {
        this.newPurchase = false
        if (payload) {
          // add it to the top of the list
          this.purchases.unshift(Object.assign({}, payload))
        }
      })

      this.panel = 0
    },

    computed: {

      seatsAvailable () {
        if (this.project && this.project.attributes.seats) {
          return parseInt(this.project.attributes.seats.available)
        }
        return 0
      },

      seatsUsed () {
        console.log(this.project)
        if (this.project && this.project.attributes.seats) {
          return parseInt(this.project.attributes.seats.used)
        }
        return 0
      },

      stickyClass () {
        if (window.innerWidth > 599) {
          if (this.scroll > 0) {
            return 'elevation-8'
          } else {
            return ''
          }
        }
      }
    },

    methods: {
      loadPurchases () {
        this.loading = true
        purchaseService.index(
          (data, total) => {
            this.purchases = data
            this.totalPurchases = total
            this.loading = false
          },
          (err) => {
            console.log(err)
          },
          this.projectId,
          this.pagination
        )
      },

      loadProject () {
        this.loading = true
        projectService.show(
          (data) => {
            this.project = data
            this.loading = false
          },
          (err) => {
            console.log(err)
          },
          this.projectId
        )
      },

      processEway () {
        projectService.purchase(
          (data) => {
            console.log('response: ', data.shared_payment_url)
            window.open(data.shared_payment_url, '_eway')
          },
          (err) => {
            console.log(err)
          },
          this.project.id
        )
      },

      checkPurchase (purchase) {
        this.checking = true
        purchaseService.check(
          (data) => {
            let index = this.purchases.findIndex(item => item.id == purchase.id)
            this.purchases[index] = data
            // refresh the list we are rendering out
            this.purchases = Object.assign([], this.purchases)
            // reload the current project to get the new seat tally
            this.checking = false
            this.loadProject()
          },
          (err) => {
            this.checking = false
            console.log(err)
          },
          this.project.id,
          purchase.id
        )
      }
    }
  }
</script>

<style lang="scss" scoped>
  .v-expansion-panel-purchases {
    background-color: #0155a8 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/purchase/index.vue